export default {"src":"/_next/static/media/program_placeholder.2f9d98ea.svg","height":321,"width":241,"blurWidth":0,"blurHeight":0};